import { cardPreviewContext } from '@context/card-preview-context';
import { useCardAttribute } from '@hooks/use-card-attributes';
import { useContext } from 'react';

import { SingleInputCardProperty } from '../SingleInputCardProperty';
import styles from './Department.module.scss';
import type { CardProperty } from '.cache/__types__';

type DepartmentProps = {
  property?: CardProperty;
  // In future, cardId could come from the cardFieldEditContext (or similar context), that way we can tell if there is no
  // cardId, that we need to create a new card before adding the property.
  cardId: string;
};

export const Department: React.FC<DepartmentProps> = ({ property, cardId }) => {
  const { hideEmptyAttributes } = useContext(cardPreviewContext);

  const cardAttributeType = useCardAttribute('department');
  if (!cardAttributeType) {
    return null;
  }

  // if hideEmptyAttributes specified as true and property value empty, then department shouldn't be shown on the card at all
  if (hideEmptyAttributes && !property?.value) {
    return <></>;
  }

  return (
    <div className={styles['user-department-container']}>
      <SingleInputCardProperty
        attribute={cardAttributeType}
        cardId={cardId}
        className={styles['user-department']}
        inputLabel="Department"
        property={property}
        defaultTemplateValueProvider={'template'}
      />
    </div>
  );
};
